import script from "./dro-dlg-resetpwd.vue?vue&type=script&setup=true&lang=ts"
export * from "./dro-dlg-resetpwd.vue?vue&type=script&setup=true&lang=ts"

import "./dro-dlg-resetpwd.vue?vue&type=style&index=0&id=2390c78e&lang=scss"

const __exports__ = script;

export default __exports__